import { render, staticRenderFns } from "./game_wheel.vue?vue&type=template&id=645f3bb7&scoped=true"
import script from "./game_wheel.vue?vue&type=script&lang=ts"
export * from "./game_wheel.vue?vue&type=script&lang=ts"
import style0 from "./game_wheel.vue?vue&type=style&index=0&id=645f3bb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645f3bb7",
  null
  
)

export default component.exports